function initializeReviewDirectories(root = document) {
  const directories = root.matches?.('.review-directory') ? [root] : root.querySelectorAll('.review-directory');
  directories.forEach((directory) => {
  if (directory.dataset.initialized) return;
  directory.dataset.initialized = 'true';
  const list = directory.querySelector('.review-directory__list');
  const controls = directory.querySelector('.review-directory__controls');
  const previous = controls.querySelector('[data-gallery-prev]');
  const next = controls.querySelector('[data-gallery-next]');
  controls.hidden = false;
  const update = () => {
    previous.disabled = list.scrollLeft <= 1;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  };
  const move = (direction) => list.scrollBy({ left: direction * list.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  list.addEventListener('scroll', update, { passive: true });
  const observer = new ResizeObserver(update);
  observer.observe(list);
  directory.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
    observer.disconnect();
    directory.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
  }, { once: true });
  update();
  directory.querySelectorAll('[data-review-media-dialog]').forEach((dialog) => {
    const opener = directory.querySelector(`[aria-controls="${dialog.id}"]`);
    const video = dialog.querySelector('video');
    if (typeof dialog.showModal !== 'function') return;
    opener.setAttribute('role', 'button');
    const open = () => {
      document.querySelectorAll('dialog[data-review-dialog][open],dialog[data-review-media-dialog][open]').forEach((other) => { if (other !== dialog) other.close(); });
      dialog.showModal();
      document.documentElement.classList.add('review-dialog-open');
      dialog.querySelector('h3').focus({ preventScroll: true });
      if (!video.dataset.initialized) {
        video.poster = video.dataset.poster;
        video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
        video.dataset.initialized = 'true';
        video.load();
      }
    };
    opener.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); open();
    });
    opener.addEventListener('keydown', (event) => { if (event.key === ' ') { event.preventDefault(); open(); } });
    dialog.querySelector('[data-review-media-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      if (!document.querySelector('dialog[data-review-dialog][open],dialog[data-review-media-dialog][open]')) document.documentElement.classList.remove('review-dialog-open');
    });
  });
});
}
initializeReviewDirectories();
document.addEventListener('shopify:section:load', (event) => initializeReviewDirectories(event.target));
